/**
 * Copyright 2019, OpenCensus Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Controls the sending of traces to exporters.
 *
 * This is based on the ExporterBuffer in the @opencensus/core package, but this
 * is modified to use only APIs available in the browser and is simplified to
 * enable a small final package size for web clients.
 * See:
 * https://github.com/census-instrumentation/opencensus-node/blob/master/packages/opencensus-core/src/exporters/exporter-buffer.ts
 */
var ExporterBuffer = /** @class */ (function () {
    function ExporterBuffer(
    /** The service to send the collected spans. */
    exporter, 
    /** Configuration object to specify bufferTimeout and bufferSize. */
    config) {
        this.exporter = exporter;
        this.config = config;
        /** Trace queue of a buffer */
        this.queue = [];
    }
    /**
     * Adds a root span to the buffer. The buffer will be flushed if the queue
     * length exceeds config.bufferSize or at least bufferTimeout milliseconds
     * have passed since the first root span was added to the buffer.
     */
    ExporterBuffer.prototype.addToBuffer = function (root) {
        var _this = this;
        this.queue.push(root);
        if (this.config.bufferSize && this.queue.length > this.config.bufferSize) {
            this.flush();
            return this;
        }
        setTimeout(function () {
            if (_this.queue.length)
                _this.flush();
        }, this.config.bufferTimeout);
        return this;
    };
    ExporterBuffer.prototype.flush = function () {
        this.exporter.publish(this.queue);
        this.queue = [];
    };
    return ExporterBuffer;
}());
export { ExporterBuffer };
//# sourceMappingURL=exporter-buffer.js.map